import Wrap from "../../components/wrap";

export default function KVKK() {
  return (
    <section className="single-page">
      <Wrap>
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">
          <div className="border-b border-slate-200 bg-slate-50 px-8 py-8">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
              Pixad Medya A.Ş.
            </p>
            <h1 className="mt-3 text-3xl font-bold leading-tight text-slate-900 md:text-4xl">
              Kişisel Verilerin İşlenmesine İlişkin Şirket Aydınlatma Metni
            </h1>
          </div>

          <div className="space-y-10 px-8 py-8 leading-7 text-slate-700">
            <p>
              Pixad Medya A.Ş., 6698 sayılı Kişisel Verilerin Korunması Kanunu
              kapsamında
              <span className="font-semibold"> “veri sorumlusu” </span>
              sıfatını haiz işletmeler arasında yer almaktadır. Reklamcılık,
              yazılım ve diğer faaliyetlerimiz kapsamında veri sorumlusu olarak
              siz değerli ziyaretçi, mal/hizmet sağlayıcı, hizmet alıcı ve diğer
              ilgilileri Kişisel Verilerin Korunması Kanunu ve ilgili
              yönetmelikler uyarınca bilgilendirmek isteriz.
            </p>

            <div className="rounded-xl border border-slate-200 bg-slate-50 p-5">
              <h2 className="text-lg font-semibold text-slate-900">
                Veri Sorumlusu
              </h2>
              <p className="mt-2">Pixad Medya A.Ş.</p>
            </div>

            <section>
              <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                Kişisel Verilerin İşlenme Amacı
              </h2>

              <p className="mt-4">
                İlgililere ait kişisel veriler, Pixad Medya A.Ş. tarafından
                sunulan hizmetlerden ilgili kişileri faydalandırmak için gerekli
                çalışmaların iş birimleri tarafından yapılması ve ilgili iş
                süreçlerinin yürütülmesi, Pixad Medya A.Ş. tarafından yürütülen
                ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimleri
                tarafından gerekli çalışmaların yapılması ve buna bağlı iş
                süreçlerinin yürütülmesi, Pixad Medya A.Ş.’nin ticari ve/veya iş
                stratejilerinin planlanması ve icrası, Pixad Medya A.Ş. ve
                Pixad Medya A.Ş. ile iş ilişkisi içerisinde olan ilgili
                kişilerin hukuki, teknik ve ticari iş güvenliğinin temini ile
                Pixad Medya A.Ş.’nin sunduğu hizmetlerin ilgili kişilere
                önerilmesi ve tanıtılması için gerekli olan aktivitelerin
                planlanması ve icrası da dahil olmak üzere 6698 sayılı Kanun’un
                5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve
                amaçları çerçevesinde işlenmektedir.
              </p>
            </section>

            <section>
              <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                Kişisel Verilerin Aktarımı
              </h2>

              <p className="mt-4">
                İlgililere ait kişisel veriler, Pixad Medya A.Ş. tarafından
                sunulan hizmetlerden ilgili kişileri faydalandırmak için gerekli
                çalışmaların iş birimleri tarafından yapılması ve ilgili iş
                süreçlerinin yürütülmesi, Pixad Medya A.Ş. tarafından yürütülen
                ticari faaliyetlerin gerçekleştirilmesi için ilgili iş birimleri
                tarafından gerekli çalışmaların yapılması ve buna bağlı iş
                süreçlerinin yürütülmesi, Pixad Medya A.Ş.’nin iş ilişkisi
                içerisinde olan ilgili kişilerin hukuki, teknik ve ticari iş
                güvenliğinin temini ile Pixad Medya A.Ş.’nin sunduğu ürün ve
                hizmetlerin ilgili kişilere önerilmesi ve tanıtılması için
                gerekli olan aktivitelerin planlanması ve icrası da dahil olmak
                üzere 6698 sayılı Kanun’un 8. maddesinde belirtilen kişisel veri
                işleme şartları ve amaçları çerçevesinde şirket yetkilileri, iş
                ortaklarımız, kanunen yetkili kamu kurum ve kuruluşları ile
                aldığınız hizmetlerin ifası için gerekli ve ilgili diğer özel
                hukuk gerçek ve tüzel kişileri ile paylaşılabilecektir.
              </p>
            </section>

            <section>
              <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                Kullanıcıların Konuya İlişkin Rızası
              </h2>

              <p className="mt-4">
                6698 sayılı Kanun’un 5. maddesinin 2. fıkrasında sayılan
                hallerde kişisel verilerin kullanıcıların açık rızası
                aranmaksızın işlenmesi mümkündür. Buna göre;
              </p>

              <ul className="mt-4 list-disc space-y-2 pl-6">
                <li>Kanunlarda açıkça öngörülmesi.</li>
                <li>
                  Fiili imkânsızlık nedeniyle rızasını açıklayamayacak durumda
                  bulunan veya rızasına hukuki geçerlilik tanınmayan kişinin
                  kendisinin ya da bir başkasının hayatı veya beden bütünlüğünün
                  korunması için zorunlu olması.
                </li>
                <li>
                  Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                  ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel
                  verilerin işlenmesinin gerekli olması.
                </li>
                <li>
                  Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi
                  için zorunlu olması.
                </li>
                <li>İlgili kişinin kendisi tarafından alenileştirilmiş olması.</li>
                <li>
                  Bir hakkın tesisi, kullanılması veya korunması için veri
                  işlemenin zorunlu olması.
                </li>
                <li>
                  İlgili kişinin temel hak ve özgürlüklerine zarar vermemek
                  kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                  işlenmesinin zorunlu olması.
                </li>
              </ul>

              <p className="mt-4">
                Bu durumlarda kullanıcılardan açık rıza alınmasına gerek
                bulunmamaktadır. Kişisel verilerin Pixad Medya A.Ş. tarafından
                kayıt edildiği haller esas olarak bu muafiyetler kapsamında yer
                almakta ve istisnai olarak muafiyet dışı kalan hallerde ise
                ilgili kişinin açık rızası alınmaksızın veri kaydı
                yapılmamaktadır. İlgililere ait kişisel veriler şirketimize ait
                kişisel veri saklama ve imha politikasına uygun olarak muhafaza
                edilmekte ve saklama süresinin sona ermesi halinde ilk imha
                döneminde silinmektedir.
              </p>
            </section>

            <section>
              <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi
              </h2>

              <p className="mt-4">
                Kişisel veriler, kullanıcılardan elektronik ortamda tamamen
                otomatik yollarla ve/veya fiziki ortamda veri kayıt sisteminin
                bir parçası olarak yarı otomatik yollarla toplanmaktadır.
                Yukarıda belirtilen hukuki sebeplerle toplanan kişisel veriler
                Kanun’un 5. ve 6. maddelerinde ve bu Aydınlatma Metninde
                belirtilen amaçlarla işlenebilmekte ve yine 6698 sayılı
                Kanun’un 8. maddesine uygun şekilde aktarılabilmektedir.
              </p>
            </section>

            <section>
              <h2 className="border-b border-slate-200 pb-2 text-2xl font-semibold text-slate-900">
                Kişisel Veri Sahibi Olarak Kullanıcıların Hakları
              </h2>

              <p className="mt-4">
                6698 sayılı Kanun’un 11. maddesi uyarınca veri sahipleri
                aşağıdaki haklara sahiptir:
              </p>

              <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kendileri ile ilgili kişisel veri işlenip işlenmediğini
                  öğrenme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kişisel verileri işlenmişse buna ilişkin bilgi talep etme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kişisel verilerin işlenme amacını ve bunların amacına uygun
                  kullanılıp kullanılmadığını öğrenme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı
                  üçüncü kişileri bilme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde
                  bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin
                  kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
                  isteme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş
                  olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan
                  kalkması hâlinde kişisel verilerin silinmesini veya yok
                  edilmesini isteme ve bu kapsamda yapılan işlemin kişisel
                  verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla
                  analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun
                  ortaya çıkmasına itiraz etme
                </li>
                <li className="rounded-xl border bg-slate-50 p-4">
                  Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle
                  zarara uğraması hâlinde zararın giderilmesini talep etme
                </li>
              </ul>

              <p className="mt-6">
                Söz konusu hakların kullanımına ilişkin taleplerinizi şirketimiz
                merkezinden veya pixad.com.tr internet adresi üzerinden temin
                edebileceğiniz Veri Sorumlusuna Başvuru Formunu doldurarak
                tarafımıza iletebilirsiniz. Ayrıca şirketimiz kayıtlarında
                tarafınıza ait ve doğrulanmış e-posta adres bilginiz bulunmakta
                ise, bu e-posta üzerinden yapacağınız başvurularınız da
                değerlendirmeye alınabilecektir. Bu kapsamdaki başvuru ve
                taleplerinize mümkün olan en kısa sürede ve en geç
                <span className="font-semibold"> 30 gün </span>
                içinde tarafımızca geri dönüş yapılmaktadır.
              </p>
            </section>
          </div>
        </div>
      </Wrap>
    </section>
  );
}